import { wrapWithMaxWidth } from '../../../echarts/util/tooltip';

export default function formatter(params) {
  return wrapWithMaxWidth(`${params.marker} <strong>${params.data.name}</strong><br/>${params.data.value}%: ${params.data.numeric} respostas${params.optionalContent || ''}`);
}
